(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-your-ingredients"] && !Shopify.designMode) return;
  try {
    
/* Optional: Add JavaScript logic if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-experts"] && !Shopify.designMode) return;
  try {
    
if (!window.alpv2ExpertBioBound) {
  window.alpv2ExpertBioBound = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-alp-bio-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.alpBioOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }
    if (event.target.matches('dialog.alp-expert-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog.alp-expert-dialog[open]').forEach(dialog => dialog.close());
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-focused-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alyve-overlay-header')) {
  customElements.define('alyve-overlay-header', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.overlay !== 'true' || this.dataset.sticky !== 'true') return;
      this.header = this.querySelector('.alpfh');
      if (!this.header) return;
      this.frame = null;
      this.update = () => {
        this.frame = null;
        const height = this.header.getBoundingClientRect().height;
        const top = this.getBoundingClientRect().top;
        this.classList.toggle('is-scrolled', height > 0 && top <= -height);
      };
      this.schedule = () => {
        if (this.frame === null) this.frame = requestAnimationFrame(this.update);
      };
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      window.addEventListener('pageshow', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.header);
      this.update();
    }
    disconnectedCallback() {
      if (!this.schedule) return;
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
      this.observer?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.classList.remove('is-scrolled');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-ingredient-benefits"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(root){
  if(!root||root.dataset.alpiReady)return;root.dataset.alpiReady='true';
  root.addEventListener('click',event=>{
   const filter=event.target.closest('[data-alpi-filter]');
   if(filter){root.querySelectorAll('[data-alpi-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));root.querySelectorAll('[data-alpi-card]').forEach(card=>{card.hidden=filter.dataset.alpiFilter!=='all'&&!card.dataset.goals.includes('|'+filter.dataset.alpiFilter+'|')});}
   const opener=event.target.closest('[data-alpi-open]');if(opener){const d=document.getElementById(opener.dataset.alpiOpen);if(d&&!d.open)d.showModal();}
   if(event.target.matches('dialog.alpi-dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();}
  });
 }
 document.querySelectorAll('[data-alpi]').forEach(init);
 document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-alpi]')));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('dialog.alpi-dialog[open]').forEach(d=>d.close()));
 document.addEventListener('shopify:block:select',e=>{const root=e.target.closest('[data-alpi]');if(root){root.querySelector('[data-alpi-filter="all"]')?.click();e.target.hidden=false;}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-ingredient-library"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('alpv2-ingredient-library')) {
  customElements.define('alpv2-ingredient-library', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._rows = Array.from(this.querySelectorAll('.alil__row'));
      this._frame = 0;
      const schedule = () => {
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => {
          if (this.isConnected && this._abort && !signal.aborted) this.measure();
        });
      };
      const preference = () => {
        this.classList.toggle('is-reduced', this._motion.matches);
        this._rows.forEach(row => { row.tabIndex = this._motion.matches ? 0 : -1; });
        schedule();
      };
      this._motion.addEventListener('change', preference, { signal });
      const visibility = () => this.classList.toggle('is-document-hidden', document.hidden);
      document.addEventListener('visibilitychange', visibility, { signal });
      visibility();
      this.addEventListener('error', event => {
        const photo = event.target;
        if (photo instanceof HTMLImageElement && photo.closest('.alil__photo')) {
          photo.parentElement.classList.add('is-unavailable');
        }
      }, { capture: true, signal });
      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        const block = Array.from(this.querySelectorAll('[data-alil-block]')).find(item => item.dataset.alilBlock === blockId);
        if (!block) return;
        const disclosure = this.querySelector('.alil__disclosure');
        if (disclosure) disclosure.open = true;
        block.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }, { signal });
      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(schedule);
        this._resize.observe(this);
      } else {
        window.addEventListener('resize', schedule, { signal });
      }
      if ('IntersectionObserver' in window) {
        this._intersection = new IntersectionObserver(entries => {
          this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
        }, { rootMargin: '120px', threshold: 0 });
        this._intersection.observe(this);
      }
      if (document.fonts) document.fonts.ready.then(() => { if (!signal.aborted) schedule(); });
      preference();
      this.classList.add('is-enhanced');
    }
    measure() {
      const speed = Math.max(5, Number(this.dataset.speed) || 25);
      this._rows.forEach((row, index) => {
        const track = row.querySelector('.alil__track');
        const original = track.querySelector('.alil__group');
        track.querySelectorAll('.alil__clone').forEach(item => item.remove());
        original.querySelectorAll('[data-alil-fill]').forEach(item => item.remove());
        const originals = Array.from(original.children);
        if (!originals.length || this._motion.matches) return;
        let repeats = 0;
        while (original.getBoundingClientRect().width < row.clientWidth + 1 && repeats < 20) {
          originals.forEach(pill => {
            const fill = pill.cloneNode(true);
            fill.dataset.alilFill = '';
            fill.setAttribute('aria-hidden', 'true');
            original.appendChild(fill);
          });
          repeats += 1;
        }
        const clone = original.cloneNode(true);
        clone.classList.add('alil__clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        track.appendChild(clone);
        const width = original.getBoundingClientRect().width;
        const duration = width / (speed * (index % 2 ? 0.92 : 1));
        row.style.setProperty('--alil-duration', duration.toFixed(3) + 's');
        row.style.setProperty('--alil-delay', (-duration * (Number(row.dataset.offset) || 0)).toFixed(3) + 's');
      });
    }
    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._resize) this._resize.disconnect();
      if (this._intersection) this._intersection.disconnect();
      cancelAnimationFrame(this._frame);
      this.querySelectorAll('.alil__clone, [data-alil-fill]').forEach(item => item.remove());
      this.classList.remove('is-enhanced', 'is-offscreen', 'is-document-hidden');
      this._abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-offer-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alp-flex-clock')) {
  customElements.define('alp-flex-clock', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.clock);
      const signature = [this.dataset.date, this.dataset.time, this.dataset.hours, this.dataset.minutes].join('|');
      if (signature !== this.signature) {
        this.signature = signature;
        this.expired = false;
        this.deadline = this.resolveDeadline(Date.now());
      }
      this.update = () => {
        const valid = Number.isFinite(this.deadline);
        this.hidden = !valid && !this.hasAttribute('data-editor');
        const seconds = valid && !this.expired ? Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000)) : 0;
        if (valid && seconds === 0) this.expired = true;
        const values = {days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60};
        Object.entries(values).forEach(([unit, value]) => {
          const node = this.querySelector('[data-unit="' + unit + '"]');
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        if (!valid || this.expired) clearInterval(this.clock);
      };
      this.update();
      if (Number.isFinite(this.deadline) && !this.expired) this.clock = setInterval(this.update, 1000);
      this.onVisible = () => this.update();
      document.addEventListener('visibilitychange', this.onVisible);
    }
    ukParts(timestamp) {
      if (!this.formatter) this.formatter = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'});
      return Object.fromEntries(this.formatter.formatToParts(timestamp).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    }
    wallTime(parts) {
      return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, 0);
    }
    ukTimestamp(parts) {
      const wall = this.wallTime(parts);
      const candidates = [...new Set([-86400000, 0, 86400000].map(delta => {
        const sample = wall + delta;
        const offset = this.wallTime(this.ukParts(sample)) - sample;
        return wall - offset;
      }))].sort((a, b) => a - b);
      const exact = candidates.filter(candidate => this.wallTime(this.ukParts(candidate)) === wall);
      return exact.length ? exact[0] : candidates[candidates.length - 1];
    }
    resolveDeadline(now) {
      const hours = Number(this.dataset.hours || 0);
      const minutes = Number(this.dataset.minutes || 0);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes) || hours < 0 || minutes < 0) return NaN;
      const duration = hours * 3600 + minutes * 60;
      if (duration > 0) return now + duration * 1000;
      const time = (this.dataset.time || '00:00').trim();
      if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
      const [hour, minute] = time.split(':').map(Number);
      const date = (this.dataset.date || '').trim();
      if (date) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return NaN;
        const [year, month, day] = date.split('-').map(Number);
        const check = new Date(Date.UTC(year, month - 1, day));
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
        return this.ukTimestamp({year, month, day, hour, minute});
      }
      const today = this.ukParts(now);
      let target = this.ukTimestamp({...today, hour, minute});
      if (target <= now) {
        const tomorrow = new Date(Date.UTC(today.year, today.month - 1, today.day + 1));
        target = this.ukTimestamp({year: tomorrow.getUTCFullYear(), month: tomorrow.getUTCMonth() + 1, day: tomorrow.getUTCDate(), hour, minute});
      }
      return target;
    }
    disconnectedCallback() {
      clearInterval(this.clock);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alyve-topic-reviews-v3')) {
  customElements.define('alyve-topic-reviews-v3', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.fitWidget();
      for(const widget of this.querySelectorAll('.alyrv__live-widget .trustpilot-widget')) {
        widget.setAttribute('data-style-alignment','center');
        widget.setAttribute('data-style-width','640px');
        if(window.Trustpilot?.loadFromElement)window.Trustpilot.loadFromElement(widget,true);
      }
      this.topic = 'All';
      this.expanded = this.expanded || new Set();
      this.instanceKey = this.instanceKey || `alyrv-${Math.random().toString(36).slice(2)}`;
      this.limit = Math.max(3, Number(this.dataset.perPage) || 6);
      this.pageSize = this.limit;
      this.list = this.querySelector('[data-alyrv-list]');
      this.status = this.querySelector('[data-alyrv-status]');
      this.more = this.querySelector('[data-alyrv-more]');
      this.addEventListener('click', event => {
        const toggle = event.target.closest('[data-alyrv-expand]');
        if(toggle && this.contains(toggle)) {
          const body=toggle.previousElementSibling;
          const open=toggle.getAttribute('aria-expanded')!=='true';
          if(open)this.expanded.add(toggle.dataset.alyrvExpand);else this.expanded.delete(toggle.dataset.alyrvExpand);
          this.setExpanded(body,open);
          toggle.setAttribute('aria-expanded',String(open));toggle.textContent=open?'Read less':'Read more';
          return;
        }
        const pill = event.target.closest('[data-alyrv-topic]');
        if (pill && this.contains(pill)) this.select(pill.dataset.alyrvTopic);
        if (event.target.closest('[data-alyrv-more]')) { this.limit += this.pageSize; this.render(); }
      }, {signal: this.controller.signal});
      this.addEventListener('keydown', event => {
        const pill = event.target.closest('[data-alyrv-topic]');
        if (!pill || !['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...this.querySelectorAll('[data-alyrv-topic]')];
        const index = buttons.indexOf(pill);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        this.select(buttons[next].dataset.alyrvTopic);
      }, {signal: this.controller.signal});
      if(window.ResizeObserver) {
        this.resizeObserver=new ResizeObserver(()=>{this.updateReadMore();this.fitWidget();});
        this.resizeObserver.observe(this.list);
        const widgetFrame=this.querySelector('.alyrv__live-widget');if(widgetFrame)this.resizeObserver.observe(widgetFrame);
      }
      window.addEventListener('resize',()=>{this.updateReadMore();this.fitWidget();},{signal:this.controller.signal});
      document.fonts?.ready.then(()=>{if(this.isConnected)this.updateReadMore();});
      this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
    async load() {
      const signal = this.controller.signal;
      try {
        const inline = this.querySelector('[data-alyrv-inline]');
        const response = inline ? null : await fetch(this.dataset.url, {signal});
        if (response && !response.ok) throw new Error('Review data unavailable');
        const data = inline ? JSON.parse(inline.textContent) : await response.json();
        if (signal.aborted) return;
        if (!Array.isArray(data.reviews) || !Array.isArray(data.topics) || !Array.isArray(data.distribution)) throw new Error('Invalid review data');
        this.reviews = data.reviews.filter(review => [4,5].includes(Number(review.stars))).sort((a,b) => String(b.date).localeCompare(String(a.date)));
        
        
        const distribution = this.querySelector('[data-alyrv-distribution]');
        distribution.replaceChildren();
        for (const rating of data.distribution) {
          const configured=this.getAttribute(`data-rating-${rating.stars}`);
          const percent=Math.round(Math.min(100,Math.max(0,Number(configured === null || configured === '' ? rating.percent : configured))));
          const row = this.el('div','alyrv__rating');
          row.append(this.el('span','',`${rating.stars}-star`));
          const track = this.el('div','alyrv__track'); track.setAttribute('aria-hidden','true');
          const fill = this.el('div','alyrv__fill'); fill.style.width = `${percent}%`; track.append(fill);
          row.append(track,this.el('span','',`${percent}%`));distribution.append(row);
        }
        const pills = this.querySelector('[data-alyrv-pills]');pills.replaceChildren();
        for (const topic of ['All',...data.topics]) {
          const button = this.el('button','alyrv__pill',topic);button.type='button';button.dataset.alyrvTopic=topic;
          button.setAttribute('role','radio');button.setAttribute('aria-checked',String(topic==='All'));button.tabIndex=topic==='All'?0:-1;pills.append(button);
        }
        this.enhancePills(pills);
        this.render();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = 'Reviews could not load. Please refresh the page.';
        if (window.Shopify?.designMode) this.status.textContent = 'Add alyve-reviews-tagged.json to theme Assets, or set the tagged review data URL.';
        this.more.hidden=true;
      }
    }
    enhancePills(pills) {
      this.orderPillsByGoals(pills);
      if (!pills.parentElement.classList.contains('alyrv__pills-nav')) {
        const nav=this.el('div','alyrv__pills-nav');
        pills.parentNode.insertBefore(nav,pills);nav.append(pills);
        const make=(dir)=>{const b=document.createElement('button');b.type='button';b.className='alyrv__pills-arrow alyrv__pills-arrow--'+dir;b.tabIndex=-1;b.setAttribute('aria-label',dir==='prev'?'Show previous filters':'Show more filters');b.innerHTML='<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="'+(dir==='prev'?'M10 3 5 8l5 5':'M6 3l5 5-5 5')+'" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';b.addEventListener('click',()=>pills.scrollBy({left:(dir==='prev'?-1:1)*Math.max(120,pills.clientWidth*0.7),behavior:'smooth'}));return b;};
        nav.append(make('prev'),make('next'));
        const update=()=>{const max=pills.scrollWidth-pills.clientWidth;nav.classList.toggle('can-prev',pills.scrollLeft>4);nav.classList.toggle('can-next',max>4&&pills.scrollLeft<max-4);};
        pills.addEventListener('scroll',update,{passive:true});
        if (window.ResizeObserver) new ResizeObserver(update).observe(pills);
        this.updatePillNav=update;
      }
      if (this.updatePillNav) this.updatePillNav();
      if (!this.goalHooks) {
        this.goalHooks=true;
        const again=()=>{this.orderPillsByGoals(pills);if(this.updatePillNav)this.updatePillNav();};
        window.addEventListener('quizResultDataReady',()=>setTimeout(again,60));
        let count=0;const timer=setInterval(()=>{again();if(++count>12)clearInterval(timer);},700);
      }
    }
    userGoals() {
      let goals=[];
      try{const q=window.quizResultData&&window.quizResultData.populatedRecords&&window.quizResultData.populatedRecords.qualities;if(Array.isArray(q))goals=q.map(x=>typeof x==='string'?x:(x&&x.name)).filter(Boolean);}catch(e){}
      if (!goals.length) goals=[...document.querySelectorAll('#product-goals li')].map(li=>{const c=li.cloneNode(true);c.querySelectorAll('style,svg,script').forEach(x=>x.remove());return (c.textContent||'').trim();}).filter(Boolean);
      return goals.map(g=>String(g).toLowerCase().trim());
    }
    orderPillsByGoals(pills) {
      const goals=this.userGoals();if(!goals.length)return;
      const buttons=[...pills.querySelectorAll('.alyrv__pill')];
      const all=buttons.find(b=>b.dataset.alyrvTopic==='All');
      const rank=b=>{const t=(b.dataset.alyrvTopic||'').toLowerCase().trim();const i=goals.findIndex(g=>g===t||g.split(/\s+/)[0]===t.split(/\s+/)[0]);return i<0?Infinity:i;};
      const matched=buttons.filter(b=>b!==all&&rank(b)!==Infinity).sort((a,b)=>rank(a)-rank(b));
      if(!matched.length)return;
      const order=[all,...matched,...buttons.filter(b=>b!==all&&!matched.includes(b))].filter(Boolean);
      if(order.every((b,i)=>buttons[i]===b))return;
      pills.append(...order);
    }
    fitWidget() {
      const frame=this.querySelector('.alyrv__live-widget');
      if(!frame)return;
      const width=frame.clientWidth;
      if(width>0)frame.style.setProperty('--alyrv-widget-scale',String(Math.min(1,width/(parseFloat(getComputedStyle(frame).getPropertyValue('--alyrv-widget-base'))||640))));
    }
    setExpanded(body,expanded) {
      body.classList.toggle('is-collapsed',!expanded);
      body.style.setProperty('display',expanded?'block':'-webkit-box','important');
      body.style.setProperty('-webkit-box-orient','vertical','important');
      body.style.setProperty('-webkit-line-clamp',expanded?'unset':'5','important');
      body.style.setProperty('max-height',expanded?'none':'120px','important');
      body.style.setProperty('overflow',expanded?'visible':'hidden','important');
    }
    updateReadMore() {
      for(const toggle of this.querySelectorAll('[data-alyrv-expand]')) {
        const body=toggle.previousElementSibling;
        toggle.hidden=toggle.getAttribute('aria-expanded')!=='true' && body.scrollHeight<=body.clientHeight+1;
      }
    }
    el(tag,className,text) {const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element;}
    highlight(target,text,ranges) {
      const characters=Array.from(text || '');let cursor=0;
      for(const [start,end] of ranges || []) {
        if(start<cursor || end>characters.length || end<=start)continue;
        target.append(document.createTextNode(characters.slice(cursor,start).join('')));
        target.append(this.el('mark','',characters.slice(start,end).join('')));cursor=end;
      }
      target.append(document.createTextNode(characters.slice(cursor).join('')));
    }
    select(topic) {
      this.topic=topic;this.limit=this.pageSize;
      for(const button of this.querySelectorAll('[data-alyrv-topic]')) {const active=button.dataset.alyrvTopic===topic;button.setAttribute('aria-checked',String(active));button.tabIndex=active?0:-1;}
      this.render();
    }
    render() {
      if(!this.reviews)return;
      const matches=this.reviews.filter(review=>this.topic==='All'||review.tags.includes(this.topic));
      const visible=matches.slice(0,this.limit);const fragment=document.createDocumentFragment();
      for(const review of visible) {
        const card=this.el('article','alyrv__card');const meta=this.el('div','alyrv__meta');
        const stars=this.el('span','alyrv__stars');stars.setAttribute('role','img');stars.setAttribute('aria-label',`${review.stars} out of 5 stars`);
        for(let i=0;i<5;i++) {
          const box=this.el('span',`alyrv__star${i<Number(review.stars)?'':' alyrv__star--empty'}`);box.setAttribute('aria-hidden','true');
          const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('focusable','false');
          const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M12 2.1 14.9 8.4 21.8 9.2 16.7 13.9 18.1 20.7 12 17.2 5.9 20.7 7.3 13.9 2.2 9.2 9.1 8.4Z');svg.append(path);box.append(svg);stars.append(box);
        }
        const reviewer=this.el('div','alyrv__reviewer');
        const avatar=this.el('span','alyrv__avatar',String(review.name||'Customer').trim().split(/\s+/).slice(0,2).map(part=>Array.from(part)[0]).join('').toUpperCase());avatar.setAttribute('aria-hidden','true');
        const author=this.el('p','alyrv__author',review.name);reviewer.append(avatar,author);card.append(reviewer);
        const date=this.el('time','',new Date(`${review.date}T12:00:00Z`).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}));date.dateTime=review.date;reviewer.append(date);meta.append(stars);card.append(meta);
        const evidence=review.highlights?.[this.topic]||{};
        if(review.title){const title=this.el('h3','');this.highlight(title,review.title,evidence.title);card.append(title);}
        const body=this.el('p','alyrv__text');this.highlight(body,review.text,evidence.text);
        const expanded=this.expanded.has(String(review.id));
        body.id=`${this.instanceKey}-${review.id}`;this.setExpanded(body,expanded);
        const toggle=this.el('button','alyrv__read-more',expanded?'Read less':'Read more');
        toggle.type='button';toggle.dataset.alyrvExpand=String(review.id);toggle.hidden=!expanded;
        toggle.setAttribute('aria-expanded',String(expanded));toggle.setAttribute('aria-controls',body.id);
        card.append(body,toggle);
        const photos=this.el('div','alyrv__photos');
        for(const template of this.querySelectorAll('template[data-alyrv-review-images]')) {
          if(template.dataset.alyrvReviewImages.trim()===String(review.id))photos.append(template.content.cloneNode(true));
        }
        if(photos.childElementCount)card.append(photos);
        
        fragment.append(card);
      }
      this.list.replaceChildren(fragment);
      this.updateReadMore();
      this.status.textContent=matches.length?`Showing ${visible.length} of ${matches.length.toLocaleString('en-GB')} selected 4- and 5-star reviews${this.topic==='All'?'':` mentioning ${this.topic.toLowerCase()}`}.`:`No 4- or 5-star reviews match ${this.topic.toLowerCase()}.`;
      this.more.hidden=this.limit>=matches.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-sticky-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const active = new WeakMap();
  function init(root) {
    if (!root || active.has(root)) return;
    const bar = root.querySelector('[data-alpq-bar]');
    if (!bar) return;
    const update = () => {
      const value = root.dataset.threshold;
      const parsed = value == null || value.trim() === '' ? 1000 : Number(value);
      const threshold = Number.isFinite(parsed) ? Math.max(0, parsed) : 1000;
      const hidden = window.scrollY < threshold;
      bar.hidden = hidden;
      bar.inert = hidden;
      bar.setAttribute('aria-hidden', String(hidden));
    };
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('pageshow', update);
    active.set(root, update); update();
  }
  document.querySelectorAll('[data-alpq-host]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-alpq-host]')));
  document.addEventListener('shopify:section:unload', e => {const root=e.target.querySelector('[data-alpq-host]'); if(root){const handler=active.get(root);if(handler){window.removeEventListener('scroll',handler);window.removeEventListener('pageshow',handler);}active.delete(root);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpv2-switch-reveal"] && !Shopify.designMode) return;
  try {
    
  function initAlpv2Switch(root) {
    if (!root || root.dataset.switchReady === 'true') return;
    const range = root.querySelector('[data-switch-range]');
    if (!range) return;
    const update = () => root.style.setProperty('--switch-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
    root.dataset.switchReady = 'true';
  }
  document.querySelectorAll('[data-alpv2-switch]').forEach(initAlpv2Switch);
  document.addEventListener('shopify:section:load', event => {
    initAlpv2Switch(event.target.querySelector('[data-alpv2-switch]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
    document.getElementById("filter_dropdown_nav").addEventListener("change", function() {
        var url = this.value;
        if (url) {
            window.location.href = url;
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
